import axiosPrivate from "../axiosPrivate";
import { GET_DOCTOR_URL } from "src/constants";

export const getDoctor = (searchFilters) => {
  return axiosPrivate.get(GET_DOCTOR_URL, { params: searchFilters });
};
